<section
  class="min-h-[calc(100vh-136px)] bg-gray-50 flex items-center justify-center px-4"
>
  <div class="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
    <h2 class="text-xl font-bold text-gray-800 mb-6">Reset Your Password</h2>

    <form [formGroup]="forgotPasswordForm" class="space-y-4">
      <!-- Email input -->
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Email</mat-label>
        <input matInput type="email" formControlName="email" />
      </mat-form-field>

      <!-- Submit button -->
      <button
        mat-flat-button
        color="primary"
        class="w-full"
        type="submit"
        (click)="reset()"
        [disabled]="pending"
      >
        Reset Password
      </button>

      <!-- Success/Error banner -->
      <div *ngIf="submitted && !pending">
        <app-banner-message
          [success]="success"
          [majorMessage]="message"
        ></app-banner-message>
      </div>

      <!-- Loading state -->
      <div *ngIf="pending" class="flex justify-center">
        <button
          type="button"
          class="w-full flex justify-center items-center px-4 py-2 font-semibold text-sm text-white bg-blue-500 hover:bg-indigo-400 rounded-md cursor-not-allowed"
          disabled
        >
          <svg
            class="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
          Processing...
        </button>
      </div>

      <!-- Back to login link -->
      <div class="mt-4">
        <a routerLink="/login" class="mat-primary text-[#1565C0] text-sm">
          Back to Login
        </a>
      </div>
    </form>
  </div>
</section>
